export * from './main.component';

